import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  BinaryOp_Eq_getInstance3k5gqsqqy0m8l as BinaryOp_Eq_getInstance,
  BinaryOp_NotEq_getInstance3tyaa09ac7jzy as BinaryOp_NotEq_getInstance,
  BinaryOp_Lt_getInstance33j0pgyd00cpr as BinaryOp_Lt_getInstance,
  BinaryOp_Gt_getInstance1daaj0ilv714d as BinaryOp_Gt_getInstance,
  BinaryOp_LtEq_getInstance13m3rw35pfurr as BinaryOp_LtEq_getInstance,
  BinaryOp_GtEq_getInstance3okul41zdqyt3 as BinaryOp_GtEq_getInstance,
  Binary3afyp00u76wim as Binary,
  BinaryOp_Concat_getInstance3f2zrl641dkzq as BinaryOp_Concat_getInstance,
  BinaryOp_Add_getInstance21e6unb8ihszv as BinaryOp_Add_getInstance,
  BinaryOp_Sub_getInstancea51dds4zxi3 as BinaryOp_Sub_getInstance,
  BinaryOp_Mul_getInstance27o8h7njrmnvz as BinaryOp_Mul_getInstance,
  BinaryOp_Div_getInstance35qfbeys2ty0v as BinaryOp_Div_getInstance,
  Percent1jcj19m9plnqy as Percent,
  BinaryOp_Pow_getInstance1mkwbubduk7i7 as BinaryOp_Pow_getInstance,
  Unary39zfajhusip1v as Unary,
  NumberNode1xmay0dkzrjy8 as NumberNode,
  TextNodehpx4og0kbkvh as TextNode,
  VarNode11doayw0szb1g as VarNode,
  BoolNode3tzl71ld7m729 as BoolNode,
  Call7ulg0xobrp7l as Call,
} from './ExcelExpr.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  isWhitespace25occ8z1ed1s9 as isWhitespace,
  isDigit3mimrri4wkzop as isDigit,
  isLetterOrDigit2kuxd9e198haf as isLetterOrDigit,
  isLettere1qnx5bysxbd as isLetter,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  toString1n9qg6fb0b5i8 as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { toDoubleOrNullkxwozihadygj as toDoubleOrNull } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/numberConversions.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ExcelParseExceptionClass;
function ExcelParseException() {
  if (ExcelParseExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(message) {
        return new.target.new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$(message);
      }
      static new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$(message) {
        var $this = this.new_kotlin_IllegalArgumentException_sfqr8_k$(message);
        captureStack($this, $this.$throwableCtor_4);
        return $this;
      }
      userMessage_astb5o_k$() {
        var tmp0_elvis_lhs = this.message;
        return tmp0_elvis_lhs == null ? "This formula can't be read." : tmp0_elvis_lhs;
      }
    }
    initMetadataForClass($, 'ExcelParseException');
    ExcelParseExceptionClass = $;
  }
  return ExcelParseExceptionClass;
}
function peek($this) {
  return $this.pos_1 < $this.tokens_1.get_size_woubt6_k$() ? $this.tokens_1.get_c1px32_k$($this.pos_1) : Companion_getInstance().Eof_1;
}
function next($this) {
  var _unary__edvuaz = $this.pos_1;
  $this.pos_1 = _unary__edvuaz + 1 | 0;
  return $this.tokens_1.get_c1px32_k$(_unary__edvuaz);
}
function match($this, type) {
  if (peek($this).type_1.equals(type)) {
    $this.pos_1 = $this.pos_1 + 1 | 0;
    return true;
  }
  return false;
}
function parseComparison($this) {
  var left = parseConcat($this);
  while (true) {
    var op;
    switch (peek($this).type_1.ordinal_1) {
      case 10:
        op = BinaryOp_Eq_getInstance();
        break;
      case 11:
        op = BinaryOp_NotEq_getInstance();
        break;
      case 12:
        op = BinaryOp_Lt_getInstance();
        break;
      case 13:
        op = BinaryOp_Gt_getInstance();
        break;
      case 14:
        op = BinaryOp_LtEq_getInstance();
        break;
      case 15:
        op = BinaryOp_GtEq_getInstance();
        break;
      default:
        op = null;
        break;
    }
    if (op == null)
      return left;
    $this.pos_1 = $this.pos_1 + 1 | 0;
    var right = parseConcat($this);
    left = new (Binary())(op, left, right);
  }
}
function parseConcat($this) {
  var left = parseAdditive($this);
  while (match($this, Type_Amp_getInstance())) {
    left = new (Binary())(BinaryOp_Concat_getInstance(), left, parseAdditive($this));
  }
  return left;
}
function parseAdditive($this) {
  var left = parseMultiplicative($this);
  while (true) {
    var op;
    switch (peek($this).type_1.ordinal_1) {
      case 3:
        op = BinaryOp_Add_getInstance();
        break;
      case 4:
        op = BinaryOp_Sub_getInstance();
        break;
      default:
        op = null;
        break;
    }
    if (op == null)
      return left;
    $this.pos_1 = $this.pos_1 + 1 | 0;
    left = new (Binary())(op, left, parseMultiplicative($this));
  }
}
function parseMultiplicative($this) {
  var left = parseExponent($this);
  while (true) {
    var op;
    switch (peek($this).type_1.ordinal_1) {
      case 5:
        op = BinaryOp_Mul_getInstance();
        break;
      case 6:
        op = BinaryOp_Div_getInstance();
        break;
      default:
        op = null;
        break;
    }
    if (op == null)
      return left;
    $this.pos_1 = $this.pos_1 + 1 | 0;
    left = new (Binary())(op, left, parseExponent($this));
  }
}
function parsePercent($this) {
  var expr = parseUnary($this);
  while (match($this, Type_Percent_getInstance())) {
    expr = new (Percent())(expr);
  }
  return expr;
}
function parseExponent($this) {
  var left = parsePercent($this);
  while (match($this, Type_Caret_getInstance())) {
    left = new (Binary())(BinaryOp_Pow_getInstance(), left, parsePercent($this));
  }
  return left;
}
function parseUnary($this) {
  var t = peek($this);
  if (t.type_1.equals(Type_Minus_getInstance())) {
    $this.pos_1 = $this.pos_1 + 1 | 0;
    return new (Unary())(true, parseUnary($this));
  }
  if (t.type_1.equals(Type_Plus_getInstance())) {
    $this.pos_1 = $this.pos_1 + 1 | 0;
    return new (Unary())(false, parseUnary($this));
  }
  return parsePrimary($this);
}
function parsePrimary($this) {
  var t = next($this);
  var tmp;
  switch (t.type_1.ordinal_1) {
    case 0:
      tmp = new (NumberNode())(t.number_1);
      break;
    case 1:
      tmp = new (TextNode())(t.string_1);
      break;
    case 2:
      tmp = parseIdentifier($this, t.string_1);
      break;
    case 16:
      var expr = parseComparison($this);
      if (!match($this, Type_RParen_getInstance()))
        throw ExcelParseException().new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$("Expected a closing ')' near position " + (peek($this).offset_1 + 1 | 0) + '.');
      tmp = expr;
      break;
    default:
      throw ExcelParseException().new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$("Unexpected '" + t.text_1 + "' at position " + (t.offset_1 + 1 | 0) + ' \u2014 check for a missing value or operator before it.');
  }
  return tmp;
}
function parseIdentifier($this, name) {
  // Inline function 'kotlin.text.uppercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var upper = name.toUpperCase();
  var tmp;
  if (peek($this).type_1.equals(Type_LParen_getInstance())) {
    $this.pos_1 = $this.pos_1 + 1 | 0;
    var args = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    if (!match($this, Type_RParen_getInstance())) {
      do {
        args.add_utx5q5_k$(parseComparison($this));
      }
       while (match($this, Type_Comma_getInstance()));
      if (!match($this, Type_RParen_getInstance()))
        throw ExcelParseException().new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$("Expected a closing ')' near position " + (peek($this).offset_1 + 1 | 0) + '.');
    }
    tmp = new (Call())(name, args);
  } else if (upper === 'TRUE') {
    tmp = new (BoolNode())(true);
  } else if (upper === 'FALSE') {
    tmp = new (BoolNode())(false);
  } else {
    tmp = new (VarNode())(name);
  }
  return tmp;
}
var ExcelParserClass;
function ExcelParser() {
  if (ExcelParserClass === VOID) {
    class $ {
      constructor(source) {
        this.tokens_1 = (new (Lexer())(source)).tokenize_i964w5_k$();
        this.pos_1 = 0;
      }
      parse_1rdbjn_k$() {
        var expr = parseComparison(this);
        if (!peek(this).type_1.equals(Type_Eof_getInstance()))
          throw ExcelParseException().new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$("Unexpected '" + peek(this).text_1 + "' at position " + (peek(this).offset_1 + 1 | 0) + ' \u2014 check for a missing operator or comma before it.');
        return expr;
      }
    }
    initMetadataForClass($, 'ExcelParser');
    ExcelParserClass = $;
  }
  return ExcelParserClass;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  Type_Number_instance = new (Type())('Number', 0);
  Type_String_instance = new (Type())('String', 1);
  Type_Ident_instance = new (Type())('Ident', 2);
  Type_Plus_instance = new (Type())('Plus', 3);
  Type_Minus_instance = new (Type())('Minus', 4);
  Type_Star_instance = new (Type())('Star', 5);
  Type_Slash_instance = new (Type())('Slash', 6);
  Type_Caret_instance = new (Type())('Caret', 7);
  Type_Percent_instance = new (Type())('Percent', 8);
  Type_Amp_instance = new (Type())('Amp', 9);
  Type_Eq_instance = new (Type())('Eq', 10);
  Type_Neq_instance = new (Type())('Neq', 11);
  Type_Lt_instance = new (Type())('Lt', 12);
  Type_Gt_instance = new (Type())('Gt', 13);
  Type_Le_instance = new (Type())('Le', 14);
  Type_Ge_instance = new (Type())('Ge', 15);
  Type_LParen_instance = new (Type())('LParen', 16);
  Type_RParen_instance = new (Type())('RParen', 17);
  Type_Comma_instance = new (Type())('Comma', 18);
  Type_Eof_instance = new (Type())('Eof', 19);
}
var Type_Number_instance;
var Type_String_instance;
var Type_Ident_instance;
var Type_Plus_instance;
var Type_Minus_instance;
var Type_Star_instance;
var Type_Slash_instance;
var Type_Caret_instance;
var Type_Percent_instance;
var Type_Amp_instance;
var Type_Eq_instance;
var Type_Neq_instance;
var Type_Lt_instance;
var Type_Gt_instance;
var Type_Le_instance;
var Type_Ge_instance;
var Type_LParen_instance;
var Type_RParen_instance;
var Type_Comma_instance;
var Type_Eof_instance;
var TypeClass;
function Type() {
  if (TypeClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'Type');
    TypeClass = $;
  }
  return TypeClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.Eof_1 = new (Token())(Type_Eof_getInstance(), '<eof>', -1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
function Type_Number_getInstance() {
  static_init();
  return Type_Number_instance;
}
function Type_String_getInstance() {
  static_init();
  return Type_String_instance;
}
function Type_Ident_getInstance() {
  static_init();
  return Type_Ident_instance;
}
function Type_Plus_getInstance() {
  static_init();
  return Type_Plus_instance;
}
function Type_Minus_getInstance() {
  static_init();
  return Type_Minus_instance;
}
function Type_Star_getInstance() {
  static_init();
  return Type_Star_instance;
}
function Type_Slash_getInstance() {
  static_init();
  return Type_Slash_instance;
}
function Type_Caret_getInstance() {
  static_init();
  return Type_Caret_instance;
}
function Type_Percent_getInstance() {
  static_init();
  return Type_Percent_instance;
}
function Type_Amp_getInstance() {
  static_init();
  return Type_Amp_instance;
}
function Type_Eq_getInstance() {
  static_init();
  return Type_Eq_instance;
}
function Type_Neq_getInstance() {
  static_init();
  return Type_Neq_instance;
}
function Type_Lt_getInstance() {
  static_init();
  return Type_Lt_instance;
}
function Type_Gt_getInstance() {
  static_init();
  return Type_Gt_instance;
}
function Type_Le_getInstance() {
  static_init();
  return Type_Le_instance;
}
function Type_Ge_getInstance() {
  static_init();
  return Type_Ge_instance;
}
function Type_LParen_getInstance() {
  static_init();
  return Type_LParen_instance;
}
function Type_RParen_getInstance() {
  static_init();
  return Type_RParen_instance;
}
function Type_Comma_getInstance() {
  static_init();
  return Type_Comma_instance;
}
function Type_Eof_getInstance() {
  static_init();
  return Type_Eof_instance;
}
var TokenClass;
function Token() {
  if (TokenClass === VOID) {
    class $ {
      constructor(type, text, offset, number, string) {
        Companion_getInstance();
        number = number === VOID ? 0.0 : number;
        string = string === VOID ? '' : string;
        this.type_1 = type;
        this.text_1 = text;
        this.offset_1 = offset;
        this.number_1 = number;
        this.string_1 = string;
      }
    }
    initMetadataForClass($, 'Token');
    TokenClass = $;
  }
  return TokenClass;
}
function skipWhitespace($this) {
  while ($this.i_1 < $this.source_1.length && isWhitespace(charCodeAt($this.source_1, $this.i_1))) {
    $this.i_1 = $this.i_1 + 1 | 0;
  }
}
function readNumber($this) {
  var start = $this.i_1;
  while ($this.i_1 < $this.source_1.length && isDigit(charCodeAt($this.source_1, $this.i_1))) {
    $this.i_1 = $this.i_1 + 1 | 0;
  }
  if ($this.i_1 < $this.source_1.length && charCodeAt($this.source_1, $this.i_1) === _Char___init__impl__6a9atx(46)) {
    $this.i_1 = $this.i_1 + 1 | 0;
    while ($this.i_1 < $this.source_1.length && isDigit(charCodeAt($this.source_1, $this.i_1))) {
      $this.i_1 = $this.i_1 + 1 | 0;
    }
  }
  var text = substring($this.source_1, start, $this.i_1);
  var tmp0_elvis_lhs = toDoubleOrNull(text);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw ExcelParseException().new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$("Invalid number '" + text + "' at position " + (start + 1 | 0) + '.');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var value = tmp;
  return new (Token())(Type_Number_getInstance(), text, start, value);
}
function readIdentifier($this) {
  var start = $this.i_1;
  while ($this.i_1 < $this.source_1.length && (isLetterOrDigit(charCodeAt($this.source_1, $this.i_1)) || charCodeAt($this.source_1, $this.i_1) === _Char___init__impl__6a9atx(95))) {
    $this.i_1 = $this.i_1 + 1 | 0;
  }
  var text = substring($this.source_1, start, $this.i_1);
  return new (Token())(Type_Ident_getInstance(), text, start, VOID, text);
}
function readString($this) {
  var start = $this.i_1;
  $this.i_1 = $this.i_1 + 1 | 0;
  var sb = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
  $l$loop: while (true) {
    if ($this.i_1 >= $this.source_1.length)
      throw ExcelParseException().new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$('Unterminated text starting at position ' + (start + 1 | 0) + ' \u2014 add a closing quote.');
    var c = charCodeAt($this.source_1, $this.i_1);
    if (c === _Char___init__impl__6a9atx(34)) {
      if (($this.i_1 + 1 | 0) < $this.source_1.length && charCodeAt($this.source_1, $this.i_1 + 1 | 0) === _Char___init__impl__6a9atx(34)) {
        sb.append_58al37_k$(_Char___init__impl__6a9atx(34));
        $this.i_1 = $this.i_1 + 2 | 0;
      } else {
        $this.i_1 = $this.i_1 + 1 | 0;
        break $l$loop;
      }
    } else {
      sb.append_58al37_k$(c);
      $this.i_1 = $this.i_1 + 1 | 0;
    }
  }
  return new (Token())(Type_String_getInstance(), substring($this.source_1, start, $this.i_1), start, VOID, sb.toString());
}
var LexerClass;
function Lexer() {
  if (LexerClass === VOID) {
    class $ {
      constructor(source) {
        this.source_1 = source;
        this.i_1 = 0;
      }
      tokenize_i964w5_k$() {
        var out = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
        skipWhitespace(this);
        while (this.i_1 < this.source_1.length) {
          var start = this.i_1;
          var c = charCodeAt(this.source_1, this.i_1);
          if (isDigit(c) || (c === _Char___init__impl__6a9atx(46) && (this.i_1 + 1 | 0) < this.source_1.length && isDigit(charCodeAt(this.source_1, this.i_1 + 1 | 0))))
            out.add_utx5q5_k$(readNumber(this));
          else if (c === _Char___init__impl__6a9atx(34))
            out.add_utx5q5_k$(readString(this));
          else if (isLetter(c) || c === _Char___init__impl__6a9atx(95))
            out.add_utx5q5_k$(readIdentifier(this));
          else {
            this.i_1 = this.i_1 + 1 | 0;
            var tmp;
            if (c === _Char___init__impl__6a9atx(43)) {
              tmp = new (Token())(Type_Plus_getInstance(), '+', start);
            } else if (c === _Char___init__impl__6a9atx(45)) {
              tmp = new (Token())(Type_Minus_getInstance(), '-', start);
            } else if (c === _Char___init__impl__6a9atx(42)) {
              tmp = new (Token())(Type_Star_getInstance(), '*', start);
            } else if (c === _Char___init__impl__6a9atx(47)) {
              tmp = new (Token())(Type_Slash_getInstance(), '/', start);
            } else if (c === _Char___init__impl__6a9atx(94)) {
              tmp = new (Token())(Type_Caret_getInstance(), '^', start);
            } else if (c === _Char___init__impl__6a9atx(37)) {
              tmp = new (Token())(Type_Percent_getInstance(), '%', start);
            } else if (c === _Char___init__impl__6a9atx(38)) {
              tmp = new (Token())(Type_Amp_getInstance(), '&', start);
            } else if (c === _Char___init__impl__6a9atx(40)) {
              tmp = new (Token())(Type_LParen_getInstance(), '(', start);
            } else if (c === _Char___init__impl__6a9atx(41)) {
              tmp = new (Token())(Type_RParen_getInstance(), ')', start);
            } else if (c === _Char___init__impl__6a9atx(44)) {
              tmp = new (Token())(Type_Comma_getInstance(), ',', start);
            } else if (c === _Char___init__impl__6a9atx(61)) {
              tmp = new (Token())(Type_Eq_getInstance(), '=', start);
            } else if (c === _Char___init__impl__6a9atx(60)) {
              var tmp_0;
              if (this.i_1 < this.source_1.length && charCodeAt(this.source_1, this.i_1) === _Char___init__impl__6a9atx(61)) {
                this.i_1 = this.i_1 + 1 | 0;
                tmp_0 = new (Token())(Type_Le_getInstance(), '<=', start);
              } else if (this.i_1 < this.source_1.length && charCodeAt(this.source_1, this.i_1) === _Char___init__impl__6a9atx(62)) {
                this.i_1 = this.i_1 + 1 | 0;
                tmp_0 = new (Token())(Type_Neq_getInstance(), '<>', start);
              } else {
                tmp_0 = new (Token())(Type_Lt_getInstance(), '<', start);
              }
              tmp = tmp_0;
            } else if (c === _Char___init__impl__6a9atx(62)) {
              var tmp_1;
              if (this.i_1 < this.source_1.length && charCodeAt(this.source_1, this.i_1) === _Char___init__impl__6a9atx(61)) {
                this.i_1 = this.i_1 + 1 | 0;
                tmp_1 = new (Token())(Type_Ge_getInstance(), '>=', start);
              } else {
                tmp_1 = new (Token())(Type_Gt_getInstance(), '>', start);
              }
              tmp = tmp_1;
            } else {
              throw ExcelParseException().new_org_thecommunitygroupinc_cares_excel_ExcelParseException_it7yp2_k$("Unexpected character '" + toString(c) + "' at position " + (start + 1 | 0) + " \u2014 this character isn't allowed in a formula.");
            }
            out.add_utx5q5_k$(tmp);
          }
          skipWhitespace(this);
        }
        out.add_utx5q5_k$(new (Token())(Type_Eof_getInstance(), '<eof>', this.i_1));
        return out;
      }
    }
    initMetadataForClass($, 'Lexer');
    LexerClass = $;
  }
  return LexerClass;
}
//region block: exports
export {
  ExcelParseException as ExcelParseException2l6x86zzipbp0,
  ExcelParser as ExcelParser16xoa9636ns39,
};
//endregion

//# sourceMappingURL=ExcelParser.mjs.map
